import { Typography } from "@mui/material";
import { JustInfo } from "../../../utils/Icon";

const TitleLabel = ({ title, required, info }) => {
  return (
    <Typography
      variant='body2'
      sx={{ mb: 1, fontWeight: 500, color: "text.secondary" }}
    >
      {title} {required && <span style={{ color: "#d32f2f" }}>*</span>}
      {info && <JustInfo title={info} />}
    </Typography>
  );
};

export default TitleLabel;
